
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DialogEmailRequired',
  computed: {
    ...mapGetters(['GET_POPUP_EMAIL_SHOWN']),
  },
  methods: {
    ...mapMutations(['SET_POPUP_EMAIL_SHOWN']),
  },
  components: {
    ReqDocs: () =>
      import(
        /* webpackChunkName: 'ReqDocs' */ '@/components/reusables/reqDocs/ReqDocs.vue'
      ),
  },
}
